module.exports = __webpack_public_path__ + "img/login_logo.a17127ad.png";